import { motion } from 'framer-motion';
import { Search, ClipboardList, Palette, Code, CheckCircle, Rocket } from 'lucide-react';

const iconMap = {
  search: Search,
  'clipboard-list': ClipboardList,
  palette: Palette,
  code: Code,
  'check-circle': CheckCircle,
  rocket: Rocket,
};

const ProcessSection = ({ process }) => {
  return (
    <section id="process" className="section-spacing" data-testid="process-section">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
            How We Work
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4">
            Our Process
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A proven methodology that delivers results every time.
          </p>
        </motion.div>

        <div className="relative">
          {/* Timeline line - desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-secondary to-accent -translate-y-1/2" />

          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-8">
            {process.map((step, index) => {
              const Icon = iconMap[step.icon] || CheckCircle;
              const isEven = index % 2 === 0;

              return (
                <motion.div
                  key={step.id}
                  initial={{ opacity: 0, y: isEven ? -20 : 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className={`relative ${isEven ? 'md:mt-0' : 'md:mt-24'}`}
                  data-testid={`process-step-${index}`}
                >
                  {/* Step number */}
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-background border-2 border-primary flex items-center justify-center text-sm font-bold text-primary z-10">
                    {index + 1}
                  </div>

                  <div className="glass-card p-6 pt-8 text-center h-full">
                    <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-4">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <h3 className="font-heading font-semibold mb-2">{step.title}</h3>
                    <p className="text-muted-foreground text-sm">{step.description}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
